<template lang="pug">
.text_box
  h2.questions_title {{ localizedName }}

  .item(
    v-for="(item, index) in answerList"
    :key="index"
    :class="{ 'selected': selected === index }"
    @click="submit(index, item)"
  ) {{ item.name }}

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getLocalizedCampaignField } from '@/utils/language'

@Component({
  props: {
    index: Number,
    data: Object
  },
  computed: {
    localizedName() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return getLocalizedCampaignField(this.data, 'displayName') || getLocalizedCampaignField(this.data, 'name') || this.data?.name || ''
    }
  }
})

class textComponents extends Vue {
  selected = null
  // answerList = this.data?.settings?.survey?.answerList ?? 0

  get answerList() {
    let answerList = this.data?.settings?.survey?.answerList ?? []
    // 重构，统一 answerList 的格式
    if (typeof answerList[0] === 'string') answerList = answerList.map(item => ({ name: item, value: item }))
    return answerList
  }

  submit(index, item) {
    this.selected = index
    const { value, campaign } = item
    this.$emit('event', value, campaign) // 暴露点击事件
  }

  _initializationData() {
    this.selected = null
  }
}

export default textComponents
</script>

<style lang="sass" scoped>
@use "../style/index" as *
.text_box
  padding: 0 16px

  .item
    margin-bottom: 10px

    &:last-child
      margin: 0

</style>